import _ from 'lodash';
import { navigationRoutes, navigationSteps } from '../../navigation/navigationHelpers.js';

export const getErrorContentPath = path => {
  const errorPages = [
    navigationSteps.myPlan.ERROR,
    navigationSteps.myPlan.CONTACTUS,
    navigationSteps.quickCheckout.ERROR,
    navigationSteps.quickCheckout.CONTACTUS,
    navigationSteps.movers.CONTACTUS,
    navigationSteps.movers.CANCELLATION_CONTACTUS,
    navigationSteps.movers.ERROR,
    navigationSteps.movers.CANCELLATION_ERROR,
    navigationSteps.myPlan.MESSAGE
  ];

  const errorContentPath = _.get(errorPages.filter(errorPage => _.startsWith(path, navigationRoutes[errorPage].path)), '[0]');

  return errorContentPath;
};



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/error/errorHelpers.js
 **/